import { GameRecordsBase } from '../../shared/models/game-records-base';
import type { GameRecordOptions } from '../../shared/models/game-record-base';
import { NbaGameRecord } from './game-record';
import type { IGame } from '../../shared/interfaces/IGame';

/**
 * NBA-specific GameRecords.
 * - teamName is a plain string (not a KO observable — NBA custom leagues don't rename teams).
 * - Deduplicates by gameGuid in initSubscribers.
 * - No Ties tracking needed (NBA doesn't have ties).
 */
export class NbaGameRecords extends GameRecordsBase {
  protected override get recordOptions(): Partial<GameRecordOptions> {
    return NbaGameRecord.NBA_OPTIONS;
  }

  constructor(
    Wins: KnockoutObservableArray<IGame>,
    Losses: KnockoutObservableArray<IGame>,
    Ties: KnockoutObservableArray<IGame>,
    teamName: string,
    fakeObs: KnockoutObservable<number | undefined>
  ) {
    super(Wins, Losses, Ties, teamName, fakeObs);
  }
}
